export default "__VITE_ASSET__B51aY38r__";